import React from 'react';

import { Heading, PropertyGroup } from '../../../../components';

import css from '../../../../containers/ListingPage/ListingPage.module.css';

const createFilterOptions = options => options.map(o => ({ key: `${o.option}`, label: o.label }));

const TypeWithIcons = ({ listing, listingConfig }) => {
  const typeSelectedValues = listing.attributes.publicData.type;
  const fieldConfig = listingConfig.listingFields.find(c => c.key === 'type');

  if (!typeSelectedValues || !fieldConfig) return null;

  const { enumOptions, showConfig } = fieldConfig;

  return (
    <div className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {showConfig.label}
      </Heading>
      <PropertyGroup
        id="type"
        options={createFilterOptions(enumOptions)}
        selectedOptions={typeSelectedValues}
        twoColumns={enumOptions.length > 5}
      />
    </div>
  );
};

export default TypeWithIcons;
